import React from "react";

const PublicChannel = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            d="M10.727 21.556l.747-7.112H4V10.89h7.849L12.782 2h3.575l-.933 8.889h7.092L23.449 2h3.575l-.933 8.889h6.353v3.555h-6.727l-.746 7.112h7.473v3.555h-7.848L23.662 34h-3.575l.933-8.889H13.93L12.996 34H9.42l.934-8.889H4v-3.555h6.727zm3.575 0h7.094l.746-7.112H15.05l-.747 7.112z"
            fill={fill}
        />
    </svg>
);

export default PublicChannel;
